import NumberFormatCustom from 'helpers/NumberFormatter';
import {type ChangeEvent, type KeyboardEvent} from 'react';
import {useTranslation} from 'react-i18next';
import GenericTextField from './TextField';

export const NumericField = ({value, fieldName, handleChange, onKeyPress, helperText, endAdornment}: INumericField) => {
  const {t} = useTranslation('common');
  return (
    <GenericTextField
      InputProps={{
        inputComponent: NumberFormatCustom as (props) => JSX.Element,
        endAdornment,
      }}
      inputProps={{'data-testid': fieldName}}
      label={t(fieldName)}
      value={value ?? ''}
      onChange={handleChange}
      onKeyPress={onKeyPress}
      helperText={helperText && t(helperText)}
    />
  );
};

interface INumericField {
  value?: number;
  fieldName: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (event: KeyboardEvent<HTMLDivElement>) => void;
  helperText?: string;
  endAdornment?: string;
}
